export default "__VITE_ASSET__BmgHdlns__"